export function generateStoreFrontUrl(
  retailerId?: string | null,
  retailerSlug?: string | null
): string | undefined {
  if (!retailerId) {
    return undefined
  }

  const path = ['', 'store', retailerId]

  if (retailerSlug) {
    path.push(retailerSlug)
  }

  return path.join('/')
}
